/*==========================================================================
				BARBA
==========================================================================*/
portfolioAPP.barba = function () {


/*==========================================================================
        homePage
==========================================================================*/
  var homePage = Barba.BaseView.extend({
    namespace: 'homePage',
    onEnter: function () {
      // The new Container is ready and attached to the DOM.
      $('body').attr( "data-currentPage", "homePage" )
      $('.nav').show()
    },
    onEnterCompleted: function () {
      // The Transition has just finished.
      if (!window.mainController) {
        window.mainController = new ScrollMagic.Controller({refreshInterval: 0})
      }
      if (portfolioAPP.onInitialise()!='isTouchDevice'){
        portfolioAPP.smoothScroll()
        portfolioAPP.homeScrollTo()
        portfolioAPP.homeAvatarHover()
      }
      portfolioAPP.onResizeHome()
      portfolioAPP.screenOrientation()
      portfolioAPP.homeAboutTabs()
      portfolioAPP.homeScrollMagic()
      if (portfolioAPP.onInitialise()=='isLargeScreen'){ portfolioAPP.homeScrollMagicLaptop() }
      portfolioAPP.homeGrid()
    
    },
    onLeave: function () {
      // A new Transition toward a new page has just started.
    },
    onLeaveCompleted: function () {
      // The Container has just been removed from the DOM.
      if (mainController) {
        mainController.destroy(true);
        mainController = null;
      }
    }
  });
  // Don't forget to init the view!
  homePage.init();
/*==========================================================================
        homePage
==========================================================================*/



/*==========================================================================
        projectsPage
==========================================================================*/
  var projectsPage = Barba.BaseView.extend({
    namespace: 'projectsPage',
    onEnter: function () {
      // The new Container is ready and attached to the DOM.
      $('body').attr( "data-currentPage", "projectsPage" )
      $('.nav').hide()
    },
    onEnterCompleted: function () {
      if (!window.mainController) {
        window.mainController = new ScrollMagic.Controller({refreshInterval: 0})
      }
      // The Transition has just finished.
      if (portfolioAPP.onInitialise()!='isTouchDevice'){
        portfolioAPP.smoothScroll()
      }
      portfolioAPP.onResizeProjects()
      portfolioAPP.screenOrientation()
      portfolioAPP.projectsPreLoader()
      portfolioAPP.projectsLinks()
    },
    onLeave: function () {
      // A new Transition toward a new page has just started.
      if (mainController) {
        mainController.destroy(true);
        mainController = null;
      }
      if (portfolioAPP.onInitialise()!='isTouchDevice' && scroll) {
        scrollBar.removeListener(portfolioAPP.projectsStickySectionLeft)
        scrollBar.removeListener(portfolioAPP.projectsStickySectionRight)
      }
    },
    onLeaveCompleted: function () {
      // The Container has just been removed from the DOM.
    }
  });
  // Don't forget to init the view!
  projectsPage.init();
/*==========================================================================
        projectsPage
==========================================================================*/

  


/*==========================================================================
        FadeTransition - FromHomePage
==========================================================================*/
  var FromHomePage = Barba.BaseTransition.extend({

    start: function () {
      //console.log('--> from home to project');

      let pageID = window.lastElementClicked.substring(window.lastElementClicked.lastIndexOf('/') + 1)
      // The Container has just been removed from the DOM. 
      $('html, body').animate({ scrollTop: $("#" + window.lastElementClicked.substring(window.lastElementClicked.lastIndexOf('/') + 1)).offset().top }, 0);

      this.newContainerLoading.then( () => {this.fadeOut(pageID)} )
    },

    fadeOut: function (pageID) {
      //console.log(pageID)

      var fadeOutTl = new TimelineMax({ onComplete: this.fadeIn.bind(this) });
      fadeOutTl
        .to($("#" + pageID + " .bgTitleSection"), .5, { opacity: 0,ease: Power1.easeOut}, "-=0")
        .to($("#" + pageID + " .sectionBg"), .5, {opacity: 0,ease: Power1.easeOut}, "-=.25")
        .to($("#" + pageID + " .bgBoxWrap"), .5, {opacity: 0,ease: Power1.easeOut}, "-=.25")
        .to($("#" + pageID + " .wrapper"), .5, {opacity: 0,ease: Power1.easeOut}, "-=.25")
        .add(function () {$('.loaderWrap').css('display', 'flex');}, "-=0")
        .to($("#" + pageID + " .slide"), .5, {opacity: 0,ease: Power1.easeOut}, "-=.25")
        .to($(".slide, .transitionFadeOut"), .5, {opacity: 0,ease: Power1.easeOut}, "-=.25")
        .to($(".gradientBgAnimation"), 1.5, {opacity: 0}, "-=0")
        
    },

    fadeIn: function () {

      function initTransition(_this_) {
        $(_this_.oldContainer).hide();
        
        ((portfolioAPP.onInitialise()=='isTouchDevice'))?window.scrollTo(0,0):scrollBar.setPosition(0,0)
        
        $(_this_.newContainer).css('display', 'block')

        _this_.done();

        var fadeInTl = new TimelineMax({})
        fadeInTl
          .add(function () {$('.loaderWrap').css('display', 'none')})
          .to('#projectsPage .content.header .projectHeader, #projectsPage .content.header .projectClayMockup', 0, {opacity: 0})
          .staggerTo('#projectsPage .content.header .projectHeader, #projectsPage .content.header .projectClayMockup', 1.5, {opacity: 1}, .5)
      }

      (function (__this) {
        let classNameNewContainer = "."+__this.newContainer.dataset.namespace+'Wrap';
        $(classNameNewContainer+" .bgImagePreload,"+ classNameNewContainer+" img.imagePreload").imagesLoaded({ background: true}, function () { initTransition(__this) })//
          .done(
            //console.log('#container background image loaded')
          )
          .progress(function (instance, image) {
            var result = image.isLoaded ? 'loaded' : 'broken';
            //console.log( 'image is ' + result + ' for ' + image.img.src );
          })
      })(this)

    }
  });


/*==========================================================================
        FadeProjectsPage
==========================================================================*/
  var FadeProjectsPage = Barba.BaseTransition.extend({
    start: function () {
      //console.log('--> from project to project');
      // Get the current page's class name from oldContainer
      let barbaContainer = $(this.oldContainer).find('.barba-container');
      let currentPageClass = '';
      if (barbaContainer.length && barbaContainer.attr('class')) {
        let classes = barbaContainer.attr('class').split(' ');
        currentPageClass = classes.find(cls => cls.includes('ProjectPage')) || '';
      }
      // The Container has just been removed from the DOM. 
      //$('html, body').animate({ scrollTop: $("#" + lastElementClicked.substring(lastElementClicked.lastIndexOf('/') + 1)).offset().top }, 0);

      this.newContainerLoading.then( () => {this.fadeOut(currentPageClass)} )
    },

    fadeOut: function (currentPageClass) {
      //console.log(currentPageClass)
      // Use the oldContainer directly if class not found, otherwise use class selector
      let $container = currentPageClass ? $("." + currentPageClass) : $(this.oldContainer);

      var fadeOutTl = new TimelineMax({ onComplete: this.fadeIn.bind(this) });
      fadeOutTl
        .to($container.find(".linksprojectsbottom"), .5, { opacity: 0,ease: Power1.easeOut}, "-=0")
        .to($container.find("#footer"), .5, {opacity: 0,ease: Power1.easeOut}, "-=.25")
        .add(function () {$('.loaderWrap').css('display', 'flex');}, "-=0")
        .to($container.find(".content"), .5, {opacity: 0,ease: Power1.easeOut}, "-=.25")
        .to($(".gradientBgAnimation"), 1.5, {opacity: 0}, "-=0")
        
    },

    fadeIn: function () {

      function initTransition(_this_) {
        $(_this_.oldContainer).hide();
        
        ((portfolioAPP.onInitialise()=='isTouchDevice'))?window.scrollTo(0,0):scrollBar.setPosition(0,0)
        
        $(_this_.newContainer).css('display', 'block')

        _this_.done();

        var fadeInTl = new TimelineMax({})
        fadeInTl
          .add(function () {$('.loaderWrap').css('display', 'none')})
          .to('#projectsPage .content.header .projectHeader, #projectsPage .content.header .projectClayMockup', 0, {opacity: 0})
          .staggerTo('#projectsPage .content.header .projectHeader, #projectsPage .content.header .projectClayMockup', 1.5, {opacity: 1}, .5)
      }

      (function (__this) {
        let classNameNewContainer = "."+__this.newContainer.dataset.namespace+'Wrap';
        $(classNameNewContainer+" .bgImagePreload,"+ classNameNewContainer+" img.imagePreload").imagesLoaded({ background: true}, function () { initTransition(__this) })//
          .done(
            //console.log('#container background image loaded')
          )
          .progress(function (instance, image) {
            var result = image.isLoaded ? 'loaded' : 'broken';
            //console.log( 'image is ' + result + ' for ' + image.img.src );
          })
      })(this)

    }
  });
/*==========================================================================
        FadeProjectsPage
==========================================================================*/





/*==========================================================================
        FadeTransition
==========================================================================*/
var FadeTransition = Barba.BaseTransition.extend({
  start: function() {
    //console.log('--> from project to home');
    Promise
      .all([this.newContainerLoading, this.fadeOut()])
      .then(this.fadeIn.bind(this));
  },

  fadeOut: function() {
    return $(this.oldContainer).animate({ opacity: 0 }).promise();
  },

  fadeIn: function() {

    var _this = this;
    var $el = $(this.newContainer);

    $(this.oldContainer).hide();
    $(window).scrollTop(0);
    $el.css({
      visibility : 'visible',
      opacity : 0
    });

    $el.animate({ opacity: 1 }, 400, function() {
      _this.done();
    });
  }
});
/*==========================================================================
        FadeTransition
==========================================================================*/



  Barba.Pjax.getTransition = function () {
    if (Barba.HistoryManager.prevStatus().namespace === 'homePage') {
      return FromHomePage;
    } else if (Barba.HistoryManager.prevStatus().namespace === 'projectsPage'  &&  window.lastElementClickedClass === 'linkToProject' ) {
        return FadeProjectsPage;
    } else {
      return FadeTransition;
    }
  };
  Barba.Pjax.start();

  Barba.Dispatcher.on("linkClicked", function (el) {
    window.lastElementClicked = el.href;
    window.lastElementClickedId = el.id;
    window.lastElementClickedClass = el.className;
  });
  Barba.Dispatcher.on("initStateChange", function (currentStatus) {});
  Barba.Dispatcher.on("newPageReady", function (currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) {
    $("body").addClass('via-barba')
  });
  Barba.Dispatcher.on("transitionCompleted", function (currentStatus, prevStatus) {
    $("body").removeClass('via-barba')
  });
};
/*==========================================================================
				BARBA
==========================================================================*/

